/**
 * Financing Calculator + Delivery Status updater
 * Uses native <dialog> with ::backdrop.
 * Listens to afterVariantChanged for price + delivery status updates.
 * Does NOT modify product-info.js.
 */
(function () {
  // Zins und maximale Laufzeit kommen aus der Aktionskonfiguration, die
  // main-product.liquid aus den Produkt-Metafeldern rendert (vh-financing-config).
  // Ohne Konfiguration: Standardkonditionen.
  var CFG = (function () {
    try {
      var el = document.getElementById('vh-financing-config');
      return el ? JSON.parse(el.textContent) : {};
    } catch (err) {
      return {};
    }
  })();
  var APR = (typeof CFG.apr === 'number' ? CFG.apr : 6.99) / 100;
  var MAX_MONTHS = CFG.maxMonths || 96;
  var MONTHLY_RATE = Math.pow(1 + APR, 1 / 12) - 1;
  var currentPrice = 0;
  var currentVariant = null; // { id, title, sku } nach Variantenwechsel
  var REQUEST_BASE = 'https://finanzierung.voltheads.de/';

  function calcMonthly(priceInCents, months) {
    var principal = priceInCents / 100;
    if (months <= 0 || principal <= 0) return 0;
    if (MONTHLY_RATE === 0) return Math.ceil(principal / months);
    return Math.ceil(
      (principal * MONTHLY_RATE) / (1 - Math.pow(1 + MONTHLY_RATE, -months))
    );
  }

  function formatEuro(amount) {
    return amount.toLocaleString('de-DE') + '€';
  }

  function formatMoney(priceInCents) {
    return (priceInCents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function getMonths() {
    var slider = document.getElementById('fin-months');
    var months = slider ? parseInt(slider.value, 10) : 72;
    return Math.min(months, MAX_MONTHS);
  }

  function getModal() {
    return document.getElementById('financing-modal');
  }

  function updateFinancing() {
    var months = getMonths();
    var monthly = calcMonthly(currentPrice, months);
    var euroStr = formatEuro(monthly);
    var moneyStr = formatMoney(currentPrice);

    var els;
    els = document.querySelectorAll('[data-fin-rate]');
    for (var i = 0; i < els.length; i++) els[i].textContent = euroStr;
    els = document.querySelectorAll('[data-fin-product-price]');
    for (var i = 0; i < els.length; i++) els[i].textContent = moneyStr;
    els = document.querySelectorAll('[data-fin-months-display]');
    for (var i = 0; i < els.length; i++) els[i].textContent = months;
    els = document.querySelectorAll('[data-fin-monthly]');
    for (var i = 0; i < els.length; i++) els[i].textContent = euroStr;

    updateRequestLink(months, monthly);
  }

  /* --- Vorbefüllung der Anfrage-Seite ---
     Übergibt Produkt, Variante, Preis und die im Rechner gewählte Laufzeit,
     damit der Kunde auf finanzierung.voltheads.de nichts doppelt eintippt. */
  function updateRequestLink(months, monthly) {
    var links = document.querySelectorAll('[data-fin-request]');
    for (var i = 0; i < links.length; i++) {
      var d = links[i].dataset;
      var params = new URLSearchParams();
      var set = function (key, value) {
        if (value !== undefined && value !== null && String(value) !== '') params.set(key, value);
      };

      var variantTitle = currentVariant ? currentVariant.title : d.finVariant;
      if (variantTitle === 'Default Title') variantTitle = '';

      set('produkt', d.finProduct);
      set('produkt_id', d.finProductId);
      set('variante', variantTitle);
      set('variante_id', currentVariant ? currentVariant.id : d.finVariantId);
      set('sku', currentVariant ? currentVariant.sku : d.finSku);
      if (currentPrice > 0) set('preis', (currentPrice / 100).toFixed(2));
      set('laufzeit', months);
      if (monthly > 0) set('rate', monthly);
      set('zins', (APR * 100).toFixed(2));
      if (CFG.promo && CFG.until) set('aktion_bis', CFG.until);
      set('quelle', d.finUrl);

      var query = params.toString();
      links[i].href = REQUEST_BASE + (query ? '?' + query : '');
    }
  }

  /* --- Delivery status update from fetched HTML --- */
  function updateDeliveryStatus(html, sectionId) {
    var source = html.getElementById('delivery-status-' + sectionId);
    var dest = document.getElementById('delivery-status-' + sectionId);
    if (source && dest) {
      dest.innerHTML = source.innerHTML;
      if (source.classList.contains('hidden')) {
        dest.classList.add('hidden');
      } else {
        dest.classList.remove('hidden');
      }
    }
  }

  // --- Open ---
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-financing-open]')) {
      var modal = getModal();
      if (modal && modal.showModal) {
        updateFinancing();
        modal.showModal();
      }
    }
  });

  // --- Close ---
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-financing-close]')) {
      var modal = getModal();
      if (modal && modal.close) modal.close();
    }
    var modal = getModal();
    if (modal && modal.open && e.target === modal) {
      modal.close();
    }
  });

  // --- Slider ---
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'fin-months') {
      updateFinancing();
    }
  });

  // --- Variant change ---
  document.addEventListener('afterVariantChanged', function (e) {
    if (!e.detail) return;

    // Update financing price
    if (e.detail.variant && e.detail.variant.price) {
      currentPrice = e.detail.variant.price;
      currentVariant = {
        id: e.detail.variant.id,
        title: e.detail.variant.title,
        sku: e.detail.variant.sku || ''
      };
      updateFinancing();
    }

    // Update delivery status from the fetched section HTML
    // afterVariantChanged is dispatched by product-info.js after it fetches new section HTML
    // We need to re-fetch the section HTML to get the delivery status
    // Instead, we intercept the fetch by hooking into product-info's rendering
    if (e.detail.sectionId) {
      var productInfo = document.querySelector('product-info[data-section="' + e.detail.sectionId + '"]');
      if (productInfo) {
        var variantId = e.detail.variant ? e.detail.variant.id : '';
        var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + e.detail.sectionId;
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            updateDeliveryStatus(html, e.detail.sectionId);
          })
          .catch(function () {});
      }
    }
  });

  // --- Init ---
  function init() {
    var wrapper = document.querySelector('.financing-button-wrapper');
    if (wrapper) {
      currentPrice = parseInt(wrapper.dataset.productPrice, 10) || 0;
    }
    updateFinancing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
